import styled from 'styled-components';
import {
  ButtonStyleProps,
  constantButtonStyles,
  getBackgroundColor,
  getBorderStyle,
  getTextColor,
} from './Button.styles';

export const IconButton = styled.svg<ButtonStyleProps>`
  ${constantButtonStyles};
  ${getBorderStyle};
  ${getTextColor};
  ${getBackgroundColor};
  border-radius: 32px;
  height: 24px;
  margin: 8px;
  width: 24px;
`;
